import CryptoJS from 'crypto-js';
import { createDirectUpload } from '../containers/CircleCommunityPage/CircleCommunityPage.duck';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

export const recordLimit = 200

export const excludedKeysOfCreatePost = ["coverImage", "coverImagefiles", "topics", 'spaceId'];

export const accessTypeData = [
  { label: 'Open To Everyone', value: 'open' },
  { label: 'Approve Members', value: 'private' },
  // { label: 'Secret', value: 'secret' },
];

export const renderNotificationTabs = [
  {
      id: 'notifications',
      name: 'Notifications',
  },
  {
      id: 'settings',
      name: 'Settings',
  },
]

export const renderSearchTabs = [
  {
      id: 'posts',
      name: 'Posts',
  },
  {
      id: 'comments',
      name: 'Comments',
  },
]

export const filterNotificationTypes = [
  "live","poll","gamification","new_course_content"
]



//sample document test data
export const testDocumentData = [
  {
    id: 1,
    name: 'documnet 1',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: 2,
    name: 'documnet 2',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: 3,
    name: 'documnet 3',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: 4,
    name: 'documnet 4', 
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: 5,
    name: 'documnet 5', 
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  }
]
//test data
export const testFolderData = [
  {
    id: '67c1bf0032cefee8c8252620',
    name: 'Test - 1721751',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: '2',
    name: 'Test - 1721751',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: '3',
    name: 'Test - 1721751',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
  {
    id: '4',
    name: 'Test - 1721751',
    folderId: 'df28147a-fcc1-47ef-a5f9-82d8c3a4ec6d',
    groupId: '1721751',
  },
];

// Convert file to MD5 hash
export const convertFileToMd5 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const binary = event.target?.result;
      if (binary) {
        const wordArray = CryptoJS.enc.Latin1.parse(binary);
        const md5 = CryptoJS.MD5(wordArray).toString();
        resolve(md5);
      } else {
        reject(new Error('Failed to read file'));
      }
    };

    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsBinaryString(file);
  });
};

// Mount file data to send
export const mountFileToSend = (file, md5) => {
  const base64 = btoa(
    md5
      .match(/\w{2}/g)
      .map(a => String.fromCharCode(parseInt(a, 16)))
      .join('')
  );
  const key = uuidv4();
  const bodyParam = {
    blob: {
      key: '',
      filename: file.name,
      content_type: file.type,
      // metadata: {
      //   identified: true,
      // },
      byte_size: file.size,
      checksum: base64,
      // size: file.size,
    },
  };
  return bodyParam;
};

const handleDirectUpload = async fileData => {
  try {
    const response = await fetch('https://app.circle.so/api/admin/v2/direct_uploads', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer i7EtV2Q2rpBabraghfe56zb4N19N43WQ`,
      },
      body: JSON.stringify(fileData),
    });
    console.log('response', JSON.stringify(response, null, 2));
    return response;
  } catch (error) { }
};

export const handleGifsUpload = async (file, dispatch) => {
  try {
    // const response = await fetch(gifUrl);
    // const blob = await response.blob();
    // const file = new File([blob], 'giphy.gif', { type: 'image/gif' });
    const md5 = await convertFileToMd5(file);
    const fileMetadata = mountFileToSend(file, md5);
    console.log('fileMetadata', JSON.stringify(fileMetadata, null, 2));

    const gifUploadResponse = await dispatch(createDirectUpload(fileMetadata, file));
    // setState(prev => [...prev, gifUploadResponse]);
    console.log('gifUploadResponse', JSON.stringify(gifUploadResponse, null, 2));
    return gifUploadResponse;
  } catch (error) { }
};

export const handleFileUpload = async (event, dispatch) => {
  const file = event;
  if (!file) return;

  try {
    const md5 = await convertFileToMd5(file);
    const fileMetadata = mountFileToSend(file, md5);
    console.log('fileMetadata', JSON.stringify(fileMetadata, null, 2));
    // const response = await handleDirectUpload(fileMetadata);
    const response = await dispatch(createDirectUpload(fileMetadata, file));
    // setState(response);
    // setState(prev => [...prev, response]);
    return response;
  } catch (error) {
    console.error('Error generating MD5 checksum:', error);
  }
};

export const createPostBodyHelper = (values, formateEditor) => {

  const bodyParam = {
    name: values.postTitle || '',
    ...(values?.coverImage?.signed_id && { cover_image: values.coverImage.signed_id }),
    // slug: values.postTitle || '',
    body: values.postDescription || '',
    is_liking_enabled: true,
    is_comments_enabled: true,
    tiptap_body: {
      // body: {
      //   type: 'doc',
      //   content: [],
      // },
      body: formateEditor,
      // inline_attachments: [],
      attachments: [],
    },
    topics: values?.topics || [],
  };
  // if (values?.postDescription) {
  //   bodyParam?.tiptap_body?.body.content.push({
  //     type: 'paragraph',
  //     content: values?.tagedUserData ? [
  //       {
  //         type: 'text',
  //         text: values?.postDescription,
  //         circle_ios_fallback_text: values?.postDescription,
  //       },
  //       ...values?.tagedUserData
  //     ] : [
  //       {
  //         type: 'text',
  //         text: values?.postDescription,
  //         circle_ios_fallback_text: values?.postDescription,
  //       },
  //     ],
  //   });
  // }

  if (values?.image) {
    values?.image?.forEach(image => {
      // bodyParam?.tiptap_body?.body.content.push({
      //   type: 'image',
      //   attrs: {
      //     url: image?.direct_upload.url,
      //     signed_id: image.signed_id,
      //     content_type: image.content_type,
      //     width: '100%',
      //     width_ratio: 1,
      //     alignment: 'center',
      //   },
      // });

      bodyParam?.tiptap_body?.attachments.push(image.signed_id);
    });
  }
  if (values?.video) {
    values?.video?.forEach(video => {
      bodyParam?.tiptap_body?.attachments.push(video.signed_id);
    });
  }
  if (values?.document) {
    values?.document?.forEach(document => {
      bodyParam?.tiptap_body?.attachments.push(document.signed_id);
    });
  }
  if (values?.gifs) {
    values?.gifs?.forEach(gif => {
      bodyParam?.tiptap_body?.attachments.push(gif.signed_id);
    });
  }
  // if (gifData) {
  //   gifData?.forEach(gif => {
  //     bodyParam?.tiptap_body?.body.content.push({
  //       type: 'image',
  //       attrs: {
  //         url: gif?.direct_upload.url,
  //         signed_id: gif.signed_id,
  //         content_type: gif.content_type,
  //         width: '100%',
  //         width_ratio: 1,
  //         alignment: 'center',
  //       },
  //     });
  //     bodyParam?.tiptap_body?.inline_attachments.push({
  //       content_type: gif.content_type,
  //       url: gif?.url,
  //       signed_id: gif.signed_id,
  //     });
  //   });
  // }

  return bodyParam;
};

export const getFilteredSpaceGroup = spaceData => {
  if (!Array.isArray(spaceData)) {
    console.error('spaceData is not an array:', spaceData);
    return []; // Return an empty array as fallback
  }

  const filteredData = spaceData?.reduce((acc, item) => {
    // Check if the space_group_id already exists in the accumulator
    const existingItem = acc.find(el => el.space_group_id === item.space_group_id);
    // If it doesn't exist, add the current item
    if (!existingItem) {
      acc.push(item);
    }

    return acc;
  }, []);
  return filteredData;
};

export const formatCreatedAt = createdAt => {
  const now = moment();
  const createdMoment = moment(createdAt);
  const duration = moment.duration(now.diff(createdMoment));

  if (duration.asHours() < 23) {
    // Show minutes/hours since posted if less than 23 hours
    if (duration.asMinutes() < 60) {
      return `${Math.floor(duration.asMinutes())} minutes ago`;
    } else {
      return `${Math.floor(duration.asHours())} hours ago`;
    }
  } else {
    // Show the date if posted more than 23 hours ago
    return createdMoment.format('MMM DD');
  }
};

export const createCommentBodyHelper = (values, formateEditor) => {
  const bodyParam = {
    comment: {
      body: values?.commentBody,
      tiptap_body: {
        // body: {
        //   type: 'doc',
        //   content: [],
        // },
        body: formateEditor,
        attachments: [],
      },
    },
  };
  // if (values?.commentBody) {
  //   bodyParam?.comment?.tiptap_body?.body.content.push({
  //     type: 'paragraph',
  //     content: values?.tagedUserData ? [
  //       {
  //         type: 'text',
  //         text: values?.commentBody,
  //         circle_ios_fallback_text: values?.commentBody,
  //       },
  //       ...values?.tagedUserData
  //     ] : [
  //       {
  //         type: 'text',
  //         text: values?.commentBody,
  //         circle_ios_fallback_text: values?.commentBody,
  //       },
  //     ],
  //   });
  // }
  if (values?.image) {
    values?.image?.forEach(image => {
      // bodyParam?.tiptap_body?.body.content.push({
      //   type: 'image',
      //   attrs: {
      //     url: image?.direct_upload.url,
      //     signed_id: image.signed_id,
      //     content_type: image.content_type,
      //     width: '100%',
      //     width_ratio: 1,
      //     alignment: 'center',
      //   },
      // });

      bodyParam?.comment?.tiptap_body?.attachments.push(image.signed_id);
    });
  }
  if (values?.video) {
    values?.video?.forEach(video => {
      bodyParam?.comment?.tiptap_body?.attachments.push(video.signed_id);
    });
  }
  if (values?.document) {
    values?.document?.forEach(document => {
      bodyParam?.comment?.tiptap_body?.attachments.push(document.signed_id);
    });
  }
  if (values?.gifs) {
    values?.gifs?.forEach(gif => {
      bodyParam?.comment?.tiptap_body?.attachments.push(gif.signed_id);
    });
  }
  return bodyParam;
};

export const getInitialValuesForComments = commentData => {
  const { tiptap_body } = commentData || {};

  const { body, attachments } = tiptap_body || {};
  const { content } = body || {};
  const paragraphItem = content?.find(item => item.type === 'paragraph');
  const textValue = paragraphItem?.content?.[0]?.text || null;

  const imageAttachments = attachments?.filter(attachment =>
    attachment.content_type.startsWith('image/')
  );

  const videoAttachments = attachments?.filter(
    attachment =>
      attachment.content_type.startsWith('video/') && !attachment.filename.endsWith('.gif')
  );

  const documentAttachments = attachments?.filter(attachment =>
    attachment.content_type.startsWith('application/')
  );

  const gifAttachments = attachments?.filter(attachment => attachment.filename.endsWith('.gif'));

  return {
    // commentBody: textValue,
    image: imageAttachments,
    video: videoAttachments,
    document: documentAttachments,
    gifs: gifAttachments,
    documentsfiles: [],
    giffiles: [],
    imagefiles: [],
    videofiles: [],
  };
};

export const getInitialValuesForEditPost = postData => {
  const { body, attachments = [] } = postData?.tiptap_body || {};
  const { content } = body || {};
  const paragraphItem = content?.find(item => item.type === 'paragraph');
  const textValue = paragraphItem?.content?.[0]?.text || null;

  const imageAttachments = attachments?.filter(attachment =>
    attachment.content_type.startsWith('image/')
  );

  const videoAttachments = attachments?.filter(
    attachment =>
      attachment.content_type.startsWith('video/') && !attachment.filename.endsWith('.gif')
  );

  const documentAttachments = attachments?.filter(attachment =>
    attachment.content_type.startsWith('application/')
  );

  const gifAttachments = attachments?.filter(attachment => attachment.filename.endsWith('.gif'));
  return {
    spaceId: postData?.space?.id || '',
    postTitle: postData?.name || '',
    postDescription: textValue,
    image: imageAttachments || [],
    video: videoAttachments || [],
    document: documentAttachments || [],
    gifs: gifAttachments || [],
    documentsfiles: [],
    giffiles: [],
    imagefiles: [],
    videofiles: [],
    topics: [],
    coverImage:{},
    coverImagefiles:{}
  };
};

export const reportReasons = [
  {
    id: 'harassment',
    name: 'Harassment',
  },
  {
    id: 'spam',
    name: 'Spam',
  },
  {
    id: 'incorrect_location',
    name: 'Incorrect space/post',
  },
  {
    id: 'against_guidelines',
    name: 'Against community guidelines',
  },
  {
    id: 'other',
    name: 'Other',
  },
];

export function abbreviateName(fullName) {
  const nameParts = fullName?.split(' ').filter(Boolean); // Split and remove empty parts
  if (nameParts?.length === 0) return ''; // Return empty string if no valid name parts
  if (nameParts?.length === 1) return nameParts?.[0][0].toUpperCase(); // Single name case

  return nameParts?.[0][0].toUpperCase() + nameParts?.[nameParts.length - 1][0].toUpperCase(); // First and last initials
}

export const mergeSpaceArraysById = (array1 = [], array2 = []) =>
  Array.from(
    [...(Array.isArray(array1) ? array1 : []), ...(Array.isArray(array2) ? array2 : [])]
      .reduce((map, item) => map.set(item.id, { ...map.get(item.id), ...item }), new Map())
      .values()
  );


export const updatePostFormValues = (event, setFormOldValues, type) => {
  return (setFormOldValues(prevState => {
    const updatedValues = {
      ...prevState,
      [type]: event,
    };

    return updatedValues;
  }))

}

export const groupSortOptions = [
  { value: 'latest', label: 'Latest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'alphabetical', label: 'Alphabetical' },
  // { value: 'popular', label: 'Popular' },
  // { value: 'active', label: 'Active' },
  // { value: 'likes', label: 'Likes' },
  // { value: 'latest_updated', label: 'Latest Updated' },
  // { value: 'oldest_updated', label: 'Oldest Updated' },
  // { value: 'latest_profile_confirmed', label: 'Latest Profile Confirmed' },
];

export const calculateTotalPages = (count = 0, perPage = 1) =>
  perPage > 0 ? Math.ceil(count / perPage) : 0;

export const getSlugFromUrl = (url) => {
  const pathSegments = new URL(url).pathname.split("/");
  const slug = pathSegments[2];
  return slug
}

//new transform function
export const transformRawContent = (rawData) => {
  const mentionRegex = /@([\w]+)/g; // Detect mentions
  const urlRegex = /(?:(?<!\S)(https?:\/\/|www\.)[^\s@]+)/g;
  // const urlRegex = /(https?:\/\/[^\s]+)/g; // Detect URLs


  const parseBlock = (block) => {
    const { text, type, entityRanges } = block;
    const content = [];
    let lastIndex = 0;

    // Create a map of entityRanges for quick lookup
    const mentionEntities = {};
    entityRanges.forEach(({ key, offset, length }) => {
      mentionEntities[offset] = { key, length };
    });

    // Iterate through text to identify mentions and links
    for (let i = 0; i < text.length; i++) {
      const entity = mentionEntities[i];

      if (entity) {
        // Add preceding text before the mention
        if (i > lastIndex) {
          const precedingText = text.slice(lastIndex, i);
          content.push({
            type: "text",
            text: precedingText,
            circle_ios_fallback_text: precedingText,
          });
        }

        // Add mention
        const mentionText = text.slice(i, i + entity.length);
        const entityData = rawData.entityMap[entity.key];

        if (entityData && entityData.type === "mention") {
          content.push({
            type: "mention",
            attrs: {
              sgid: entityData?.data?.mention?.sgid,
            },
            circle_ios_fallback_text: mentionText,
          });
        } else {
          content.push({
            type: "text",
            text: mentionText,
            circle_ios_fallback_text: mentionText,
          });
        }

        lastIndex = i + entity.length;
        i += entity.length - 1; // Skip processed characters
      }
    }

    // Handle remaining text and extract links
    const remainingText = text.slice(lastIndex);
    if (remainingText) {
      let match;
      let currentIndex = 0;
      while ((match = urlRegex.exec(remainingText)) !== null) {
        const matchStart = match.index;
        const matchEnd = matchStart + match[0].length;

        // Add text before the URL
        if (currentIndex < matchStart) {
          content.push({
            type: "text",
            text: remainingText.slice(currentIndex, matchStart),
            circle_ios_fallback_text: remainingText.slice(currentIndex, matchStart),
          });
        }

        // Add URL as a link
        content.push({
          type: "text",
          marks: [
            {
              type: "link",
              attrs: {
                href: match[0],
                target: "_blank",
              },
            },
          ],
          text: match[0],
        });

        currentIndex = matchEnd;
      }

      // Add remaining text after the last URL
      if (currentIndex < remainingText.length) {
        content.push({
          type: "text",
          text: remainingText.slice(currentIndex),
          circle_ios_fallback_text: remainingText.slice(currentIndex),
        });
      }
    }

    // Handle block types
    switch (type) {
      case "unstyled":
        return { type: "paragraph", content };
      case "unordered-list-item":
        return {
          type: "bulletList",
          content: [
            {
              type: "listItem",
              content: [{ type: "paragraph", content }],
            },
          ],
        };
      case "ordered-list-item":
        return {
          type: "orderedList",
          attrs: { start: 1 },
          content: [
            {
              type: "listItem",
              content: [{ type: "paragraph", content }],
            },
          ],
        };
      case "header-two":
        return { type: "heading", attrs: { level: 2 }, content };
      case "header-three":
        return { type: "heading", attrs: { level: 3 }, content };
      case "blockquote":
        return { type: "blockquote", content };
      default:
        return { type: "paragraph", content };
    }
  };

  // Transform each block
  const content = rawData.blocks.map(parseBlock);

  return {
    type: "doc",
    content,
  };
};


// export const transformRawContent = (rawData) => {
//   const mentionRegex = /@([\w]+)/g; // Capture only alphanumeric characters after '@'

//   const parseBlock = (block) => {
//     const { text, type, entityRanges } = block;
//     const content = [];
//     let lastIndex = 0;
//     let match;

//     // Create a map of entityRanges for quick lookup
//     const mentionEntities = {};
//     entityRanges.forEach(({ key, offset, length }) => {
//       mentionEntities[offset] = { key, length };
//     });

//     while ((match = mentionRegex.exec(text)) !== null) {
//       const mentionIndex = match.index;
//       const mentionText = match[0];

//       // Add preceding text before mention
//       if (mentionIndex > lastIndex) {
//         const precedingText = text.slice(lastIndex, mentionIndex);
//         content.push({
//           type: "text",
//           text: precedingText,
//           circle_ios_fallback_text: precedingText,
//         });
//       }

//       const entity = mentionEntities[mentionIndex];
//       if (entity) {
//         const entityData = rawData.entityMap[entity.key];
//         if (entityData && entityData.type === "MENTION") {
//           content.push({
//             type: "mention",
//             attrs: {
//               sgid: entityData.data.sgid,
//             },
//             circle_ios_fallback_text: mentionText,
//           });
//         } else {
//           // Fallback to plain text if entity data is missing or incorrect
//           content.push({
//             type: "text",
//             text: mentionText,
//             circle_ios_fallback_text: mentionText,
//           });
//         }
//       } else {
//         content.push({
//           type: "text",
//           text: mentionText,
//           circle_ios_fallback_text: mentionText,
//         });
//       }

//       lastIndex = mentionIndex + mentionText.length; // Update lastIndex to include the length of the mention
//     }

//     // Add remaining text after the mention
//     const remainingText = text.slice(lastIndex);
//     if (remainingText) {
//       content.push({
//         type: "text",
//         text: remainingText,
//         circle_ios_fallback_text: remainingText,
//       });
//     }

//     // Handle block type
//     if (type === "unstyled") {
//       return { type: "paragraph", content };
//     } else if (type === "unordered-list-item") {
//       return {
//         type: "bulletList",
//         content: [
//           {
//             type: "listItem",
//             content: [{ type: "paragraph", content }],
//           },
//         ],
//       };
//     } else if (type === "ordered-list-item") {
//       return {
//         type: "orderedList",
//         attrs: { start: 1 },
//         content: [
//           {
//             type: "listItem",
//             content: [{ type: "paragraph", content }],
//           },
//         ],
//       };
//     } else if (type === "header-two") {
//       return {
//         type: "heading",
//         attrs: { level: 2 },
//         content,
//       };
//     }
//     else if (type === "header-three") {
//       return {
//         type: "heading",
//         attrs: { level: 3 },
//         content,
//       };
//     } else if (type === "blockquote") {
//       // Handle blockquote specifically
//       return {
//         type: "blockquote",
//         content,
//       };
//     }


//     // Default to paragraph if type is not explicitly handled
//     return { type: "paragraph", content };
//   };

//   // Transform each block
//   const content = rawData.blocks.map(parseBlock);

//   return {
//     type: "doc",
//     content,
//   };
// };

export const editorTypes = [
  { label: "Heading 2", key: "header-two", },
  { label: "Heading 3", key: "header-three", },
  { label: "Bold", key: "BOLD", },
  { label: "Bulleted list", key: "unordered-list-item" },
  // { label: "Blockquote", key: "blockquote" },
  // { label: "Code Block", key: "code-block" },
];

//updated reverseTransformContent
export const reverseTransformContent = (desiredJSON) => {
  const parseNode = (node) => {
    switch (node.type) {
      case "text":
        return { text: node.text, length: node.text.length, entity: null };
      case "mention":
        return {
          text: node.circle_ios_fallback_text,
          length: node.circle_ios_fallback_text.length,
          entity: {
            type: "mention",
            mutability: "SEGMENTED",
            data: { mention: { sgid: node.attrs.sgid } },
          },
        };
      default:
        return null;
    }
  };

  const parseContent = (content) => {
    let text = "";
    const entityRanges = [];
    const entityMap = {};
    let entityCounter = 0;

    content.forEach((node) => {
      const parsedNode = parseNode(node);
      if (parsedNode) {
        // Append text
        const startOffset = text.length;
        text += parsedNode.text;

        // Handle entities (mentions)
        if (parsedNode.entity) {
          entityMap[entityCounter] = parsedNode.entity;
          entityRanges.push({
            offset: startOffset,
            length: parsedNode.length,
            key: entityCounter,
          });
          entityCounter += 1;
        }
      }
    });

    return { text, entityRanges, entityMap };
  };

  const parseBlock = (block) => {
    const { content } = block;
    const { text, entityRanges, entityMap } = parseContent(content);

    let type = "unstyled";
    switch (block.type) {
      case "paragraph":
        type = "unstyled";
        break;
      case "bulletList":
        type = "unordered-list-item";
        break;
      case "orderedList":
        type = "ordered-list-item";
        break;
      case "heading":
        type = block.attrs.level === 2 ? "header-two" : "header-three";
        break;
      case "blockquote":
        type = "blockquote";
        break;
    }

    return {
      block: {
        key: Math.random().toString(36).substr(2, 5), // Generate random key
        text,
        type,
        depth: 0,
        inlineStyleRanges: [],
        entityRanges,
        data: {},
      },
      entityMap,
    };
  };

  const blocks = [];
  let finalEntityMap = {};

  desiredJSON?.content.forEach((block) => {
    const { block: parsedBlock, entityMap } = parseBlock(block);
    blocks.push(parsedBlock);

    // Merge entity maps
    finalEntityMap = { ...finalEntityMap, ...entityMap };
  });

  return {
    blocks,
    entityMap: finalEntityMap,
  };
};


// export const reverseTransformContent = (structuredData) => {
//   const parseContent = (node) => {
//     let text = "";
//     const entityRanges = [];
//     const entityMap = {};

//     node.content.forEach((child, index) => {
//       if (child.type === "text") {
//         text += child.text || "";
//       } else if (child.type === "mention") {
//         const mentionText = child.circle_ios_fallback_text || "";
//         const offset = text.length;
//         const length = mentionText.length;
//         text += mentionText;

//         // Add entity for the mention
//         const entityKey = Object.keys(entityMap).length;
//         entityRanges.push({ key: entityKey, offset, length });
//         entityMap[entityKey] = {
//           type: "MENTION",
//           mutability: "IMMUTABLE",
//           data: {
//             sgid: child.attrs.sgid,
//           },
//         };
//       }
//     });

//     return { text, entityRanges, entityMap };
//   };

//   const parseBlock = (block) => {
//     if (block.type === "paragraph" || block.type === "heading") {
//       const { text, entityRanges, entityMap } = parseContent(block);
//       return {
//         block: {
//           type: block.type === "paragraph" ? "unstyled" : "header-two",
//           text,
//           entityRanges,
//         },
//         entityMap,
//       };
//     } else if (block.type === "bulletList") {
//       const listItem = block.content[0]; // Assume one listItem per bulletList
//       const { text, entityRanges, entityMap } = parseContent(listItem.content[0]);
//       return {
//         block: {
//           type: "unordered-list-item",
//           text,
//           entityRanges,
//         },
//         entityMap,
//       };
//     } else if (block.type === "orderedList") {
//       const listItem = block.content[0];
//       const { text, entityRanges, entityMap } = parseContent(listItem.content[0]);
//       return {
//         block: {
//           type: "ordered-list-item",
//           text,
//           entityRanges,
//         },
//         entityMap,
//       };
//     } else if (block.type === "blockquote") {
//       const { text, entityRanges, entityMap } = parseContent(block);
//       return {
//         block: {
//           type: "blockquote",
//           text,
//           entityRanges,
//         },
//         entityMap,
//       };
//     }

//     // Default case for unhandled types
//     const { text, entityRanges, entityMap } = parseContent(block);
//     return {
//       block: {
//         type: "unstyled",
//         text,
//         entityRanges,
//       },
//       entityMap,
//     };
//   };

//   let blocks = [];
//   let entityMap = {};

//   structuredData?.content.forEach((block) => {
//     const { block: parsedBlock, entityMap: blockEntityMap } = parseBlock(block);
//     blocks.push(parsedBlock);

//     // Merge entity maps
//     Object.keys(blockEntityMap).forEach((key) => {
//       entityMap[Object.keys(entityMap).length] = blockEntityMap[key];
//     });
//   });

//   return {
//     blocks,
//     entityMap,
//   };
// };

export const getFirstImageItem = (tiptap_body) => {
  // Check the attachments array first
  const firstImageFromAttachments = tiptap_body?.attachments?.find(
    item => item.content_type.startsWith("image")
  );

  // If not found in attachments, check inline_attachments
  if (firstImageFromAttachments) {
    return firstImageFromAttachments;
  }

  const firstImageFromInlineAttachments = tiptap_body?.inline_attachments?.find(
    item => item.content_type.startsWith("image")
  );

  // Return the result from inline_attachments or null if not found
  return firstImageFromInlineAttachments || null;
};

export const formatDataForReplyComment = (jsonData, author) => {

  const mentionData = {
    type: "mention",
    attrs: {
      sgid: author?.rich_text_field_sgid
    },
    circle_ios_fallback_text: `@${author?.name}`
  };
  const contentArray = jsonData?.comment?.tiptap_body?.body?.content;

  // Check if the first item is a paragraph
  if (contentArray.length > 0 && contentArray[0].type === "paragraph") {
    // Prepend custom data to the first item's content array
    contentArray[0].content.unshift(mentionData);
  } else {
    // Create a new paragraph object with custom data
    const newParagraph = {
      type: "paragraph",
      content: [mentionData]
    };
    // Prepend the new paragraph to the content array
    contentArray.unshift(newParagraph);
  }
  return jsonData
}

export const  getRandomItemWithPriority = (primaryJSON, secondaryJSON, bannerJson) => {
  // Helper function to filter and get a random item
  const getRandomItemFromArray = (jsonArray, excludeJson) => {
    const filteredArray = jsonArray?.filter(
      (item) => JSON.stringify(item) !== JSON.stringify(excludeJson)
    );

    if (filteredArray.length === 0) {
      return null; // No suitable items found
    }

    const randomIndex = Math.floor(Math.random() * filteredArray.length);
    return filteredArray[randomIndex];
  };

  // Try to get a random item from primary JSON
  const randomItemFromPrimary = getRandomItemFromArray(primaryJSON, bannerJson);
  if (randomItemFromPrimary) {
    return randomItemFromPrimary;
  }

  // If no item found in primary JSON, try secondary JSON
  return getRandomItemFromArray(secondaryJSON, bannerJson);
}
